import { tap } from "rxjs";

import { LOCAL_STORAGE_KEYS } from "@/data_source/constants";
import { observableFromAbortableRequest } from "@/utils/map";
import request from "@/utils/request";

import {
  type APIResetPasswordRequest,
  type APISignInRequest,
  type APISignInResponse
} from "../models/APISignIn";

export function signIn(data: APISignInRequest) {
  request.setGlobalHeader({
    Authorization: ""
  });
  return observableFromAbortableRequest(
    request.postRequest<APISignInRequest, APISignInResponse>(
      "api/token/",
      data,
      {
        "content-type": "application/json",
        Authorization: ""
      }
    )()
  ).pipe(
    tap((response) => {
      localStorage.setItem("token", response.data.access);
      localStorage.setItem(
        LOCAL_STORAGE_KEYS.REFRESH_TOKEN,
        response.data.refresh
      );
      document.cookie = `auth_token=${response.data.access}; Path=/; Domain=.sitehubpro.com; SameSite=Lax; Secure; Max-Age=${4 * 60 * 60}`;
      request.setGlobalHeader({
        Authorization: `Bearer ${response.data.access}`
      });
    })
  );
}
export function sendPasswordRecoveryEmail(email: string) {
  request.setGlobalHeader({
    Authorization: ""
  });
  return observableFromAbortableRequest(
    request.postRequest(
      "api/accounts/send-reset-password-link/",
      {
        login: email
      },
      {
        "content-type": "application/json",
        Authorization: ""
      }
    )()
  );
}
export function resetPassword(data: APIResetPasswordRequest) {
  request.setGlobalHeader({
    Authorization: ""
  });
  return observableFromAbortableRequest(
    request.postRequest("api/accounts/reset-password/", data, {
      "content-type": "application/json",
      Authorization: ""
    })()
  );
}
